import { useState, useMemo, useCallback } from "react";
import { Ico } from "./Icons";
import { contentCatalogStore } from "../contentCatalogStore";
import { useSnapshot } from "valtio";
import { TagGroup } from "@models/tagGroup.model";

interface TagGroupSectionProps {
    group: TagGroup
}

export default function TagGroupSection({ group }: TagGroupSectionProps) {
    const [open, setOpen] = useState(true);
    const [filterQ, setFilterQ] = useState("");

    const { selectedTagIds } = useSnapshot(contentCatalogStore)

    const toggleTag = useCallback(
        (toggleId: number) => {
            const current = contentCatalogStore.selectedTagIds;
            contentCatalogStore.selectedTagIds = current.includes(toggleId)
                ? current.filter((tagId: number) => tagId !== toggleId)
                : [...current, toggleId];
        },
        [],
    );

    const filtered = useMemo(() => {
        if (!filterQ.trim()) return group.tags;
        return group.tags.filter((t) => t.name.toLowerCase().includes(filterQ.toLowerCase()));
    }, [group.tags, filterQ]);

    const activeCount = group.tags.filter((t) => selectedTagIds.includes(t.id)).length;

    return (
        <div className="tg-section">
            <button className="tg-header" onClick={() => setOpen((p) => !p)}>
                <span className="tg-name">{group.name}</span>
                <div className="tg-header-right">
                    {activeCount > 0 && <span className="tg-badge">{activeCount}</span>}
                    {open ? <Ico.ChevronDown /> : <Ico.ChevronRight />}
                </div>
            </button>
            {open && (
                <div className="tg-body">
                    {group.tags.length >= 5 && (
                        <div className="tg-search-wrap">
                            <Ico.Search />
                            <input className="tg-search" type="text" placeholder="Filter..."
                                value={filterQ} onChange={(e) => setFilterQ(e.target.value)} />
                            {filterQ && (
                                <button className="tg-search-clear" onClick={() => setFilterQ("")}>
                                    <Ico.X size={8} />
                                </button>
                            )}
                        </div>
                    )}
                    <div className="tg-tags">
                        {filtered.length === 0 && <p className="tg-no-match">No matches</p>}
                        {filtered.map((tag) => {
                            const active = selectedTagIds.includes(tag.id);
                            return (
                                <label key={tag.id} className={`tg-tag${active ? " active" : ""}`}>
                                    <input type="checkbox" checked={active} onChange={() => toggleTag(tag.id)}
                                        style={{ position: "absolute", opacity: 0, pointerEvents: "none" }} />
                                    <span className="tg-check">{active && <Ico.X size={7} />}</span>
                                    {tag.name}
                                </label>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}
